import sample_01 from './dynamic-allround-chem-arc.png';

export const dynamicAllroundChemArcImpressions = {
    sample_01,
};
